import { PublicDebtSearchResponse } from "@/pages/pagar/types";

const API_BASE = import.meta.env.VITE_API_BASE_URL ?? "http://localhost:5000/api";
const TENANT_ID = import.meta.env.VITE_PORTAL_TENANT_ID ?? "demo";

type JsonRecord = Record<string, unknown>;

export async function searchPublicDebts(query: string): Promise<PublicDebtSearchResponse> {
  const value = query.trim();
  if (!value) {
    throw new Error("Debes ingresar un RUT o número de contrato.");
  }

  const response = await fetch(`${API_BASE}/portal/public/debts/search?q=${encodeURIComponent(value)}`, {
    headers: {
      "x-tenant-id": TENANT_ID,
    },
  });

  if (!response.ok) {
    const message = await parseErrorMessage(response);
    throw new Error(message ?? `No se pudo buscar deuda (${response.status})`);
  }

  return (await response.json()) as PublicDebtSearchResponse;
}

export async function createPublicWebpayIntent(input: {
  contractId: string;
  documentIds: string[];
  returnUrl?: string;
}): Promise<{ paymentIntentId: string; redirectUrl: string }> {
  const response = await fetch(`${API_BASE}/portal/public/payments/intent/webpay`, {
    method: "POST",
    headers: {
      "content-type": "application/json",
      "x-tenant-id": TENANT_ID,
    },
    body: JSON.stringify(input),
  });

  if (!response.ok) {
    const message = await parseErrorMessage(response);
    throw new Error(message ?? `No se pudo iniciar pago en Transbank (${response.status})`);
  }

  return (await response.json()) as { paymentIntentId: string; redirectUrl: string };
}

export async function commitPublicWebpay(
  token: string,
): Promise<{ paymentIntentId: string; status: string; contractId: string }> {
  const response = await fetch(`${API_BASE}/portal/public/payments/commit/webpay`, {
    method: "POST",
    headers: {
      "content-type": "application/json",
      "x-tenant-id": TENANT_ID,
    },
    body: JSON.stringify({ token }),
  });

  if (!response.ok) {
    const message = await parseErrorMessage(response);
    throw new Error(message ?? `No se pudo confirmar pago en Transbank (${response.status})`);
  }

  return (await response.json()) as { paymentIntentId: string; status: string; contractId: string };
}

async function parseErrorMessage(response: Response): Promise<string | null> {
  const payload = (await response.json().catch(() => null)) as JsonRecord | null;
  if (!payload) return null;

  if (typeof payload.message === "string") return payload.message;
  if (Array.isArray(payload.message) && typeof payload.message[0] === "string") {
    return String(payload.message[0]);
  }

  return null;
}
